import { cached } from "../lib/cache";
import { osmPlaces, type OsmItem } from "../core/osm";
import type { Place } from "./weather";

/**
 * Nominatim — последняя ступень поиска места, а не основная.
 *
 * Их политика использования ограничивает нас одним запросом в секунду и
 * ПРЯМО запрещает автодополнение. Поэтому сюда приходят только запросы,
 * на которых все варианты Open-Meteo вернули пусто, и только по явному
 * действию человека — Enter или «Слушать». На пути набора с дебаунсом
 * этой функции нет и быть не должно.
 *
 * Ключа не требует, CORS открыт (проверено 2026-09-15: из браузера
 * приходит access-control-allow-origin: *). Данные под ODbL, поэтому
 * атрибуция OpenStreetMap обязательна — она в строке credits.
 */
const ENDPOINT = "https://nominatim.openstreetmap.org/search";

/** Держим неделю, как и геокодинг Open-Meteo: города не переезжают. */
export async function searchOsm(q: string, lang = "ru"): Promise<Place[]> {
  return cached(`osm:${lang}:${q.toLowerCase().trim()}`, 7 * 864e5, () => load(q, lang));
}

async function load(q: string, lang: string): Promise<Place[]> {
  const qs = new URLSearchParams({
    q,
    format: "jsonv2",
    limit: "5",
    addressdetails: "1",
    "accept-language": lang,
  });
  const r = await fetch(`${ENDPOINT}?${qs}`);
  if (!r.ok) throw new Error(`Nominatim ответил ${r.status}`);
  const raw = (await r.json()) as OsmItem[];
  // id geonames у OSM нет — при смене языка такое место переразрешится
  // обратным геокодером, других зацепок у него не остаётся.
  return osmPlaces(Array.isArray(raw) ? raw : []).map((p) => ({ ...p, nameLang: lang }));
}
